import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'bulma/css/bulma.min.css';


// import App from './App';
import Home from "./routes/Home";
import ErrorPage from "./routes/Error-page";
import Dashboard from "./routes/Dashboard";
import DashboardTwo from "./routes/DashboardTwo";
import SignUp from "./routes/SignUp";
import SignupSuccess from "./routes/SignupSuccess";
import Register from "./routes/Register";
import GetAllUsers from "./routes/AllUsers";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "dashboard-2",
    element: <DashboardTwo />,
  },
  {
    path: "getallusers",
    element: <GetAllUsers />,
  },
  {
    path: "register",
    element: <Register />,
  },
  {
    path: "signup-success",
    element: <SignupSuccess />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    {/* <App /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
